import { Button as RebassButton } from 'rebass/styled-components'
import styled from 'styled-components'
import { transparentize } from 'polished'

const StyledButton = styled(RebassButton)`
  text-transform: uppercase;
  cursor: pointer;
  height: 100%;
  width: 100%;
  border-radius: 0;
  transition: all 0.3s ease;
  letter-spacing: ${(props) => props.theme.letterSpacing};

  &:disabled {
    opacity: 0.3;
  }

  &:hover {
    box-shadow: 0 0 20px -1px ${(props) => transparentize(0.5, props.theme.colors.primary)};
  }
`

const Button = (props) => <StyledButton {...props} />

export default Button
